import React from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import PaymentMethodCard from '@/components/residents/payments/PaymentMethodCard';
import { hasPaymentMethodCardExpired } from '@/utils/residents/paymentUtils';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';

type Props = {
  methods: any[];
  isUpdating: boolean;
  onSetAsDefault: (method: any) => void;
  onDelete: (method: any) => void;
};

export const PaymentMethodsGrid: React.FC<Props> = ({ methods, isUpdating, onSetAsDefault, onDelete }) => {
  return (
    <ScrollView
      style={styles.cardsScroll}
      contentContainerStyle={styles.methodsGrid}
      showsVerticalScrollIndicator={false}
      showsHorizontalScrollIndicator={false}
    >
      {methods.map((method, index) => {
        const isExpired = hasPaymentMethodCardExpired((method as any)?.expiry);
        return (
          <View key={String((method as any).id || (method as any).sourceId)} style={styles.methodItem}>
            <PaymentMethodCard
              method={method as any}
              index={index}
              isOnlyCard={methods.length === 1}
              isExpired={isExpired}
              onSetAsDefault={() => onSetAsDefault(method)}
              onDelete={() => onDelete(method)}
              isUpdating={isUpdating}
            />
          </View>
        );
      })}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  cardsScroll: { flex: 1 },
  methodsGrid: { flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between' },
  methodItem: { width: '48%', marginBottom: 16 },
});

export default PaymentMethodsGrid;


